import React from "react";
import {useLocation} from "react-router-dom";
import styled, { withTheme } from "styled-components/macro";

import orange from "@material-ui/core/colors/orange";
import { CardContent, Card as MuiCard, Typography } from "@material-ui/core";
import { spacing } from "@material-ui/system";

import { Bar } from "react-chartjs-2";
import {GET_APP_LOCALIZE_TEXT} from "../../../../utils/dq_lc_service/lc_service";
import {scroll} from "./scrollButtons.plugin";

const Card = styled(MuiCard)(spacing);

const Spacer = styled.div(spacing);

const ChartWrapper = styled.div`
  padding: 0px;
  height: 300px;
  width: 100%;
`;

const colors = [
    "#78a8dd",
    "#b9d7a7",
    "#5b5c5c",
]

function BarChart({theme, labels, datasets, header = "", legend = "true", titleX = undefined, titleY = undefined}) {

  const location = useLocation();
  const pageLc = location.pathname.split('/')[1];

  const division = 10;
  const min = 0;
  const max = division;

  const data = {
    labels: labels.slice(min, max),
    datasets: datasets.map((dataset, index) =>
      ({
        label: dataset.label,
        backgroundColor: colors[index],
        borderColor: colors[index],
        hoverBackgroundColor: colors[index],
        hoverBorderColor: colors[index],
        data: dataset.data.slice(min, max),
        barPercentage: 1,
        categoryPercentage: 0.5,
        order: 1,
      })
    )
  };

  const options = {
    maintainAspectRatio: false,
    legend: {
      display: legend,
      position: 'bottom',
      labels: {
        fontColor: '#666',
        fontStyle: 'bold',
        boxWidth: 40,
        usePointStyle: false,
      }
    },
    layout: {
        padding: {
            right: 20
        }
    },
    scales: {
      yAxes: [
          {
              scaleLabel: {
                  display: !!titleY,
                  labelString: titleY,
              },
              gridLines: {
                  display: true,
              },
              stacked: false,
              ticks: {
                  beginAtZero: true,
              },
          },
      ],
      xAxes: [
        {
            scaleLabel: {
                display: !!titleX,
                labelString: titleX,
            },
            stacked: false,
            gridLines: {
                color: "transparent",
            },
            ticks: {
                maxRotation: 0,
                min: min,
                max: max
            },
        },
      ],
    },
    plugins: {
        scroll: {
            values: labels,
            datasets: datasets,
            division: division
        }
    }
  };

  return (
      <>
        <ChartWrapper>
          <Typography variant="h4" gutterBottom align={'center'}>
            {header}
          </Typography>
          <Bar data={data} options={options} plugins={[scroll]} />
        </ChartWrapper>
      </>


  );
}

export default withTheme(BarChart);
